<template lang="html">
  <div class="action-title" v-if="isShow">
    <div class="back" @click="back">
      <i class="iconfont icon-youjiantou"></i>
    </div>
    <div class="title">{{ title }}</div>
    <!-- <div class="close" @click="hideActionSheet"><i class="iconfont icon-guanbi"></i></div> -->
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'

export default {
  props: {
    title: {
      type: String,
      default: ''
    },
    // needArrow: {
    //     type: Boolean,
    //     default: false
    // },
    backFunction: {
      type: Function,
      default: () => {}
    },
    isShow: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    ...mapMutations(['hideActionSheet', 'setArrowState']),
    back() {
      // this.backFunction()
      // this.hideActionSheet()
      if (this.viewName === 'addressSheet') {
        this.$$tracker('110101', '20000', 21040)
      } else if (this.viewName === 'workers') {
        this.$$tracker('110101', '20000', 21041)
      } else if (this.viewName === 'calendar') {
        this.$$tracker('110101', '20000', 21044)
      }
      this.$router.go(-1)
    }
  },
  computed: {
    ...mapState(['needArrow'])
  }
}
</script>

<style lang="scss" scoped>
@import '../../assets/css/mixin';
.action-title {
  top: 0;
  right: 0;
  left: 0;
  width: 100%;
  text-align: center;
  height: rem(80px);
  font-size: rem(28px);
  @include border(bottom);
  position: absolute;
  background: #fff;
  z-index: 51;

  .title {
    line-height: rem(80px);
  }
  .close {
    position: absolute;
    right: rem(20px);
    top: 50%;
    margin-top: rem(-23px);
  }
  .icon-guanbi {
    font-size: rem(46px);
    color: #666;
  }
  .back {
    position: absolute;
    left: 0.2rem;
    top: 50%;
    margin-top: rem(-20px);
    .icon-youjiantou {
      display: block;
      font-size: rem(40px);
      color: #666;
      transform: rotate(-180deg);
    }
  }
}
</style>
